import { render, staticRenderFns } from "./ActivityLogsItem.vue?vue&type=template&id=10699078&scoped=true"
import script from "./ActivityLogsItem.vue?vue&type=script&lang=js"
export * from "./ActivityLogsItem.vue?vue&type=script&lang=js"
import style0 from "./ActivityLogsItem.vue?vue&type=style&index=0&id=10699078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10699078",
  null
  
)

export default component.exports